define.alias("shared/components/shared-ig-media-card", "calendar/components/shared-ig-media-card");